import {
  REQUEST_FAQ_LIST,
  REQUEST_FAQ,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCreateFaq({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/faq/create-faq', payload)
    .then((res) => {
      return res.data
    })
  },

  requestFaqList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get('/admin/faq/faq-list', {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_FAQ_LIST, res.data)
    })
  },

  requestDeleteFaqs({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/faq/delete-faqs', payload)
    .then((res) => {
      return res.data
    })
  },

  requestFaq({commit}, faqSeq) {
    return axiosInst.springAxiosInst.get(`/admin/faq/faq/${faqSeq}`)
    .then((res) => {
      commit(REQUEST_FAQ, res.data)
    })
  },

  requestEditFaq({}, payload) {
    return axiosInst.springAxiosInst.post(`/admin/faq/faq-edit/${payload.faqSeq}`, payload)
    .then((res) => {
      return res.data
    })
  },
}